/**
 * List Schema of ResponsavelFilial
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'

/* TODO: review generated schema */
export class ListResponsavelFilialSchema extends Schema {
  readonly name = 'ListResponsavelFilial'

  readonly fieldSet: FieldSet<ResponsavelFilial> = {
    idFilialPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpjBase: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
